import * as tslib_1 from "tslib";
import { OnChanges, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { LoaderService } from 'src/app/loader.service';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import Utils from 'src/app/utils/utils';
import { SubscriptionService } from '../../subscription.service';
import { subscriptionCreateSuccessAlert, subscriptionOperationFailureAlert } from '../../subscription.create-alert';
var CreateDaprResetComponent = /** @class */ (function () {
    function CreateDaprResetComponent(subsService, loader, alertService, toasterService, dialog) {
        this.subsService = subsService;
        this.loader = loader;
        this.alertService = alertService;
        this.toasterService = toasterService;
        this.dialog = dialog;
        this.context = null;
        this.formGroup = new FormGroup({
            ruleName: new FormControl(null),
            city: new FormControl(null),
            services: new FormControl([]),
            priority: new FormControl(null),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            ruleType: new FormControl({ value: 'qualityReset', disabled: true }),
            minValue: new FormControl(null),
            ruleAmount: new FormControl(null),
            strikedOutAmount: new FormControl(null),
            periodInDays: new FormControl(null)
        });
        this.services = [];
        this.today = moment().startOf('hour').toDate();
        this.tomorrowEod = moment().endOf('day').minutes(30).add(1, 'days').toDate();
        this.minEndDate = this.tomorrowEod;
        this.Utils = Utils;
        this.overlappingRules = [];
        this.lastServiceKey = '';
    }
    Object.defineProperty(CreateDaprResetComponent.prototype, "taxInfoText", {
        get: function () {
            return this.context && this.context.exclusiveOfTax
                ? 'This amount is exclusive of tax'
                : 'This amount is inclusive of tax';
        },
        enumerable: true,
        configurable: true
    });
    CreateDaprResetComponent.prototype.ngOnInit = function () {
        this.applyContext();
    };
    CreateDaprResetComponent.prototype.ngOnChanges = function () {
        this.applyContext();
    };
    CreateDaprResetComponent.prototype.formValue = function (name) {
        return this.formGroup.get(name).value;
    };
    CreateDaprResetComponent.prototype.blockInvalidNumberKeys = function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    };
    CreateDaprResetComponent.prototype.rejectNonPositiveAmount = function (event, controlName) {
        var input = event.target;
        if (input.value === '' || input.value == null) {
            return;
        }
        if (Number(input.value) <= 0) {
            this.formGroup.get(controlName).setValue(null);
            input.value = '';
        }
    };
    CreateDaprResetComponent.prototype.changeInDate = function () {
        var startDate = this.formValue('startDate');
        if (startDate) {
            this.minEndDate = startDate;
        }
        var endDate = this.formValue('endDate');
        if (endDate) {
            this.maxStartDate = endDate;
        }
    };
    CreateDaprResetComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message
        }));
    };
    CreateDaprResetComponent.prototype.validateField = function (fieldName, message) {
        var value = this.formValue(fieldName);
        if (!value) {
            this.errorMessage(message);
            throw new Error(message);
        }
        return value;
    };
    CreateDaprResetComponent.prototype.createDaprResetRule = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ruleName, city, selectedIds, byId_1, services, startTime, endTime, priority, minValue, ruleAmount, periodInDays, serviceDetailIds, exclusiveOfTax, existing, payload, resp, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        ruleName = this.validateField('ruleName', 'Rule name is required');
                        city = this.validateField('city', 'City is required');
                        selectedIds = this.formValue('services') || [];
                        if (!selectedIds.length) {
                            this.errorMessage('Services is required');
                            throw new Error('Services is required');
                        }
                        byId_1 = {};
                        this.services.forEach(function (service) {
                            byId_1[service.id] = service;
                        });
                        services = selectedIds.map(function (id) { return byId_1[id]; }).filter(Boolean);
                        if (!services.length) {
                            this.errorMessage('Services is required');
                            throw new Error('Services is required');
                        }
                        startTime = moment(this.validateField('startDate', 'Purchase Start date is required').getTime()).unix();
                        endTime = moment(this.validateField('endDate', 'Purchase End date is required').getTime()).unix();
                        priority = this.validateField('priority', 'Priority is required');
                        minValue = this.validateField('minValue', 'Min value is required');
                        ruleAmount = this.validateField('ruleAmount', 'Purchase price is required');
                        periodInDays = this.validateField('periodInDays', 'Period in days is required');
                        serviceDetailIds = services.map(function (s) { return s.serviceDetailId; });
                        exclusiveOfTax = !!(this.context && this.context.exclusiveOfTax);
                        if (this.formValue('strikedOutAmount') && this.formValue('strikedOutAmount') <= ruleAmount) {
                            this.errorMessage('Original price should be greater than purchase price');
                            throw new Error('Original price should be greater than purchase price');
                        }
                        return [4 /*yield*/, this.subsService.getSamePriorityRules(serviceDetailIds, startTime, endTime, [priority]).toPromise()];
                    case 2:
                        existing = _a.sent();
                        if (existing && existing.length > 0) {
                            this.overlappingRules = existing;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/];
                        }
                        payload = {
                            type: 'CASHBACK',
                            rules: [{
                                    ruleName: ruleName,
                                    startTime: startTime,
                                    endTime: endTime,
                                    priority: Number(priority),
                                    city: city.id,
                                    services: services.map(function (s) { return s.id; }),
                                    serviceDetails: serviceDetailIds,
                                    mode: this.context.mode.id,
                                    isAutoAssignedToHH: false,
                                    isAutoAssignedToMC: false,
                                    isDefaultSubscription: false,
                                    exclusiveOfTax: exclusiveOfTax,
                                    userSelectors: [],
                                    userSelectorName: null,
                                    excludeIncentiveTypes: [],
                                    ruleType: 'qualityReset',
                                    suspendServicesPostExpiry: true,
                                    rule: [{
                                            variable: 'commission',
                                            operator: '=',
                                            value: 0,
                                            type: 'flat'
                                        }],
                                    validity: [{ type: 'dapr', minValue: Number(minValue) }],
                                    ruleAmount: Number(ruleAmount),
                                    strikedOutAmount: this.formValue('strikedOutAmount'),
                                    periodInDays: Number(periodInDays),
                                    isRecommended: false
                                }]
                        };
                        return [4 /*yield*/, this.subsService.createSubscriptionRules(payload).toPromise()];
                    case 3:
                        resp = _a.sent();
                        this.alertService.open(subscriptionCreateSuccessAlert(resp, { configRequestKind: 'subscription' }));
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        this.alertService.open(subscriptionOperationFailureAlert(error_1));
                        return [3 /*break*/, 6];
                    case 5:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CreateDaprResetComponent.prototype.applyContext = function () {
        if (!this.context) {
            return;
        }
        this.formGroup.get('city').setValue(this.context.city, { emitEvent: false });
        var modeId = this.context.mode && this.context.mode.id;
        var nextServices = (this.context.modeServices || []).map(function (service) { return Object.assign({}, service, {
            mode: modeId,
            label: service.name + (service.active === false ? ' (inactive)' : '')
        }); });
        var key = (this.context.mode && this.context.mode.id) + ':' + nextServices.map(function (service) { return service.id; }).join(',');
        this.services = nextServices;
        if (key !== this.lastServiceKey) {
            this.lastServiceKey = key;
            this.formGroup.get('services').setValue([], { emitEvent: false });
        }
    };
    return CreateDaprResetComponent;
}());
export { CreateDaprResetComponent };
